import { request } from "./request";
import { API_ENDPOINTS } from "./networkConstant";

export const getStudents = async () => {
  return await request(API_ENDPOINTS.GETSTUDENTS, "POST");
};

export const editStudent = async (studentData: any) => {
  return await request(API_ENDPOINTS.EDITSTUDENT, "POST", studentData);
};

export const addStudent = async (studentData: any) => {
  return await request(API_ENDPOINTS.SIGNUP, "POST", studentData);
};

export const deleteUser = async (id: any) => {
  return await request(API_ENDPOINTS.DELETEUSER, "POST", { id });
};

export const signIn = async (signinData) => {
  return await request(API_ENDPOINTS.SIGNIN, "POST", signinData);
};

export const getAssignments = async () => {
  return await request(API_ENDPOINTS.GETASSIGNMENTS, "POST");
};

  export const submitAnswer = async (data:any) =>{
    return await request(API_ENDPOINTS.SUBMITANSWER,"POST",data,true)
  }

  export const  getGrievances = async () =>{
    return await request(API_ENDPOINTS.GETGRIEVANCE,"POST")
  }
  
  export const deleteGrievance = async (data:any) =>{
    return await request(API_ENDPOINTS.DELETEGRIEVANCE,"POST",{id:data})
  }

export const deleteAssignment = async (id: number) => {
  return await request(API_ENDPOINTS.DELETEASSIGNMENT, "POST", { id });
};

export const deleteRequest = async (id: number) => {
  return await request(API_ENDPOINTS.DELETEONLINECLASSREQUEST, "POST", { id });
};

export const getRequests = async () => {
  return await request(API_ENDPOINTS.GETONLINECLASSREQUESTS, "POST");
};

export const getMentors = async () => {
  return await request(API_ENDPOINTS.GETMENTORS, "POST");
};

  export const addMentor = async (mentorData:any) => {
    return await request(API_ENDPOINTS.ADDMENTOR, "POST",mentorData,true);
  };
  export const editMentor = async (mentorData:any) => {
    return await request(API_ENDPOINTS.EDITMENTOR, "POST",mentorData,true);
  };
  export const approveTutor = async (data:any) => {
    return await request(API_ENDPOINTS.APPROVETUTOR, "POST",data);
  };
  export const getStats= async () => {
    return await request(API_ENDPOINTS.GETUSERSTATS, "GET");
  };
  export const getAssignmentActivity= async (range:any) => {
    return await request(`${API_ENDPOINTS.GETASSIGNMENTSTATS}${range}`, "GET");
  };
  export const getNotifications= async (userId:any) => {
    return await request(`${API_ENDPOINTS.GETNOTIFICATIONS}${userId}`, "GET");
  };
  export const markAsResolved = async (data:any) =>{
    return await request(API_ENDPOINTS.MARKASRESOLVED,"POST",{id:data})
  }
  export const getOtherServices = async () => {
    return await request(API_ENDPOINTS.GETOTHERSERVICESLIST, "GET");
  };
  export const updateStatus = async (data:any) => {
    return await request(API_ENDPOINTS.UPDATESTATUS, "POST",data);
  };
  export const changePassword = async (data:any) => {
    return await request(API_ENDPOINTS.CHANGEPASSWORD, "POST",data);
  };
  export const getPaymentHistory = async () => {
    return await request(API_ENDPOINTS.PAYMENTHISTORY, "GET");
  };
  export const getDemoClassRequests = async () => {
    return await request(`${API_ENDPOINTS.GETDEMOCLASSREQUEST}`, "GET");
  };
  export const updateDemoStatus = async (data:any) => {
    return await request(API_ENDPOINTS.UPDATEDEMOSTATUS, "POST",data);
  };
  export const getCounsellingRequests = async () => {
    return await request(API_ENDPOINTS.GETCOUNSELLINGLIST, "POST");
  };